import { useState } from 'react'

export default function useTimelineTrackVisibility({
    defaultShowMicroVolume = true,
    defaultShowMesoVolume = true,
    defaultShowMacroFocus = true,
    defaultShowMacroPhase = true,
    defaultShowProgramLength = true,
    defaultShowMonth = true,
} = {}) {
    const [showMicroVolume, setShowMicroVolume] = useState(defaultShowMicroVolume)
    const [showMesoVolume, setShowMesoVolume] = useState(defaultShowMesoVolume)
    const [showMacroFocus, setShowMacroFocus] = useState(defaultShowMacroFocus)
    const [showMacroPhase, setShowMacroPhase] = useState(defaultShowMacroPhase)
    const [showProgramLength, setShowProgramLength] = useState(defaultShowProgramLength)
    const [showMonth, setShowMonth] = useState(defaultShowMonth)

    const displaySettingsOptions = [
        { label: 'Micro Volume', checked: showMicroVolume, setChecked: setShowMicroVolume },
        { label: 'Meso Volume', checked: showMesoVolume, setChecked: setShowMesoVolume },
        { label: 'Macro Focus', checked: showMacroFocus, setChecked: setShowMacroFocus },
        { label: 'Macro Phase', checked: showMacroPhase, setChecked: setShowMacroPhase },
        { label: 'Program Length', checked: showProgramLength, setChecked: setShowProgramLength },
        { label: 'Month', checked: showMonth, setChecked: setShowMonth },
    ]

    return {
        showMicroVolume,
        showMesoVolume,
        showMacroFocus,
        showMacroPhase,
        showProgramLength,
        showMonth,
        displaySettingsOptions,
    }
}
